"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const base_models_1 = require("@integration/base-models");
const BaseEntity_1 = tslib_1.__importDefault(require("../BaseEntity"));
const enums_1 = require("../enums");
class PropositionProduct extends BaseEntity_1.default {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '513866', description: 'Product ID' }),
    tslib_1.__metadata("design:type", String)
], PropositionProduct.prototype, "cdtProductId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(enums_1.ProductType)),
    (0, base_models_1.Docs)({ example: enums_1.ProductType.ELECTRICITY, description: 'Proposition product type' }),
    tslib_1.__metadata("design:type", String)
], PropositionProduct.prototype, "type", void 0);
exports.default = PropositionProduct;
